<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <router-view ref="page" :key="$route.fullPath"></router-view>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  data() {
    return {
      visitedRoutes: []
    }
  },
  watch: {
    '$route.fullPath': {
      immediate: true,
      handler(fullPath) {
        if (this.visitedRoutes.indexOf(fullPath) === -1) {
          this.visitedRoutes.push(fullPath)
          return
        }
        this.$nextTick(() => {
          const page = this.$refs.page
          if (page && typeof page.getList === 'function') {
            page.getList()
          }
        })
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.app-main {
  height: calc(100vh - 100px);
  min-height: 0;
  overflow: auto;
}

.app-main > .app-container,
.app-main > [class*="-list-page"],
.app-main > [class*="-form-page"] {
  height: 100% !important;
  min-height: 0 !important;
}

@media (max-width: 1024px) {
  .app-main {
    height: calc(100vh - 60px);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue